import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import translate from '@translate';
import {
    getTransportPackageTypesListFetchFailure,
    getTransportPackageTypesListFetchSuccess,
    syncCatalogueTransportPackageTypesFetchFailure,
    syncCatalogueTransportPackageTypesFetchSuccess,
    syncTransportPackageTypesFetchFailure,
    syncTransportPackageTypesFetchSuccess,
    getTransportPackageTypesListFetch,
} from './reducer';
import { TransportPackageType } from 'src/types/transportPackageType';

const getListRequest = async () => {
    const res = await api('get', 'api/secure/transports/package-types?active=0');
    return res.data?.data ?? res.data;
};

function* getListFetch() {
    try {
        const response: TransportPackageType[] = yield call(getListRequest);
        yield put(getTransportPackageTypesListFetchSuccess(response));
    } catch (error) {
        yield put(getTransportPackageTypesListFetchFailure());
    }
}

export function* getTransportPackageTypesListFetchWatch() {
    yield takeEvery('transportPackageTypesList/getTransportPackageTypesListFetch', getListFetch);
}

const syncGeisRequest = async () => {
    const res = await api('post', 'api/secure/transports/package-types/sync', {});
    return res.data;
};

function* syncGeisFetch() {
    try {
        yield call(syncGeisRequest);
        yield put(
            syncTransportPackageTypesFetchSuccess({
                messageSuccess: { title: translate('transportPackageTypes.message.synced') },
            })
        );
        yield put(getTransportPackageTypesListFetch());
    } catch (error) {
        yield put(syncTransportPackageTypesFetchFailure());
    }
}

export function* syncTransportPackageTypesFetchWatch() {
    yield takeEvery('transportPackageTypesList/syncTransportPackageTypesFetch', syncGeisFetch);
}

const syncCatalogueRequest = async () => {
    const res = await api('post', 'api/secure/transports/package-types/sync-catalogue', {});
    return res.data;
};

function* syncCatalogueFetch() {
    try {
        yield call(syncCatalogueRequest);
        yield put(
            syncCatalogueTransportPackageTypesFetchSuccess({
                messageSuccess: { title: translate('transportPackageTypes.message.syncedCatalogue') },
            })
        );
        yield put(getTransportPackageTypesListFetch());
    } catch (error) {
        yield put(syncCatalogueTransportPackageTypesFetchFailure());
    }
}

export function* syncCatalogueTransportPackageTypesFetchWatch() {
    yield takeEvery(
        'transportPackageTypesList/syncCatalogueTransportPackageTypesFetch',
        syncCatalogueFetch
    );
}
